import React from "react";

import { Link } from "react-router-dom";

import { Flex, Stack, Image, Button, Text } from "@chakra-ui/react";

import useTranslations from "../../../hooks/useTranslations";

import ReportLayout from "../layout/ReportLayout";

import SuccessReportScreenIllustration from "../../../assets/success_report_screen";

export default function SuccessPage() {
  const t = useTranslations();

  return (
    <ReportLayout>
      <Flex
        direction="column"
        flexGrow={1}
        bgColor="primary.50"
        py={["8", "24"]}
        px={["4", "16", "20", "36"]}
        overflowY="auto"
      >
        <Flex
          direction="column"
          flexGrow={1}
          bgColor="white"
          w="full"
          h="full"
          rounded="md"
          shadow="md"
          alignItems="center"
          justify="space-evenly"
        >
          <Image
            maxW="100%"
            w="400px"
            h="300px"
            src={SuccessReportScreenIllustration}
          />
          <Stack direction="column" spacing={["4", "6"]}>
            <Text
              textAlign="center"
              fontSize="4xl"
              fontWeight="bold"
              color="brand"
            >
              {t("reports.success.reportSentSuccessfully")}
            </Text>
            <Text textAlign="center">{t("reports.success.answersSent")}</Text>
          </Stack>

          <Button
            as={Link}
            to="/"
            size="lg"
            colorScheme="primary"
            id="success-back-to-home"
          >
            {t("reports.success.backToDashboard")}
          </Button>
        </Flex>
      </Flex>
    </ReportLayout>
  );
}
